"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Email = _interopRequireDefault(require("../../../../molecules/Email/Email"));
var _HoursOfOperation = _interopRequireDefault(require("../../../../molecules/HoursOfOperation"));
var _Location = _interopRequireDefault(require("../../../../molecules/Location"));
var _Call = _interopRequireDefault(require("../../../../molecules/Call"));
require("./location_base.css");
var _HoursOfOperation2 = require("../../../../molecules/HoursOfOperation/HoursOfOperation");
var _default = function _default(_ref) {
  var address = _ref.address,
    phoneNumber = _ref.phoneNumber,
    email = _ref.email,
    hours = _ref.hours;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, address && /*#__PURE__*/_react["default"].createElement(_Location["default"], {
    address: address
  }), phoneNumber && /*#__PURE__*/_react["default"].createElement(_Call["default"], {
    phoneNumber: phoneNumber
  }), email && /*#__PURE__*/_react["default"].createElement(_Email["default"], {
    email: email
  }), (0, _HoursOfOperation2.isHoursAvailable)(hours) && /*#__PURE__*/_react["default"].createElement(_HoursOfOperation["default"], {
    className: "location-collection-hoo",
    hours: hours,
    displayOption: "grouped"
  }));
};
exports["default"] = _default;